export default "__VITE_ASSET__DqJ6PZ2C__"